<script>
    import { ThemeWrapper } from 'svelte-themer'
    import Toolbox from './Toolbox.svelte';
    import {themes} from "./themes";
</script>


<ThemeWrapper themes="{themes}">
    <Toolbox />
</ThemeWrapper>

<style>
    :global(html) {
        background-color: var(--theme-colors-background);
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
    }

    :global(.button) {
        all: unset;
        height: inherit;
        box-sizing: border-box;
        border-radius: 10px;
        border: solid var(--theme-colors-border) 1px;
        margin: 0 5px;
        padding: .5em 1em .5em 1em;
        cursor: pointer;
        background: var(--theme-colors-background-button);
        display: flex;
        align-items: center;
    }
</style>